export const defaultOptions: any = {
    //responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        alignToPixels: true,
        grid: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
  
      },
      x: {
        type: 'time',
        time: {
          unit: 'day',
          stepSize: 1,
          /* displayFormats: {
             minute: 'HH:mm'
           }*/
        },
        ticks: {
          display: true,
          //autoSkip: true,
          source: "data",
          maxRotation: 0,
          //maxTicksLimit: 5,
          padding: 4,
          /* major: {
             enabled: true
           },*/
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        }
      }
    }
  
  };


  export const defaultDataSet = {
    borderWidth: 1,
    borderColor: '#00000000',
    fill: true,
    barThickness: 10,
    borderRadius: 3,
    
  }